import React from 'react';
import MUTypography from '../../../../../ui/MUTypography';
import './styles.css';

const Info3 = (props) =>
  <div>
    <MUTypography variant='h4' className={props.classes.h4}>
    API Usage
    </MUTypography>
    <br/>

    <MUTypography variant='h5' paragraph={true} className={props.classes.h5}>
    Production Integration Flow
    </MUTypography>
    <div style={{ textAlign: 'center', marginBottom: 20 }}>
      <img
        src={`${process.env.PUBLIC_URL}/static/images/diagram.png`}
        alt='Production Integration Flow Diagram'
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    </div>
    <MUTypography variant='display1' className={props.classes.paragraph}>
    To start using Albaraka APIs in the Production environment, the following steps must be completed:
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>1. Customer Registration and Application:</b><br/>
    Corporate customers wishing to access the production environment must first be an Albaraka Türk customer. Subsequently, the API Usage Agreement and Request Form provided by our institution must be completely filled out and signed.<br/>
    You can request the agreement and form by contacting us via the Support page or by sending an email directly to <a href='mailto:albarakaapi@albarakaturk.com.tr' style={{fontWeight: 'bold'}}>albarakaapi@albarakaturk.com.tr</a>.
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>2. IP Authorization:</b><br/>
    In the filled-out Request Form, the static IP addresses of the servers from which API requests will be sent must be declared. In accordance with our security policies, only requests originating from the IP addresses you have declared and which have been authorized by us will be accepted.
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>3. Public Key Sharing:</b><br/>
    RSA encryption (Signing) is mandatory for request security. You are required to submit the Public Key you have generated to us, in accordance with the standards detailed in the "Signing" section of this document.
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>4. Definition and Activation:</b><br/>
    The submitted documents, IP addresses, and Public Key information will be verified and defined in the system by us. Following this process, your access to the production environment will be activated.
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>5. Access Information:</b><br/>
    Once the necessary registration procedures are completed, the client informations required for the production environment will be sent to the email address registered in our system. Using these credentials, a token can be obtained via the authorization methods found under the Authorization Section, thereby providing authorization to use the APIs.<br/>
    You can find detailed information regarding the Authorization step for both the test and production environments in the Authorization tab.
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    5.1. Access for Environment
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
    Following Authorization, the base URLs and example URLs you will use to send requests to the APIs are as follows:
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>Base URL for Production Environment:</b><br/>
    <a href='https://api.albarakaturk.com.tr/api' style={{fontWeight: 'bold'}}>https://api.albarakaturk.com.tr/api</a>
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>Example URL for Production Environment:</b><br/>
    <a href='https://api.albarakaturk.com.tr/api/accounts/v1/list' style={{fontWeight: 'bold'}}>https://api.albarakaturk.com.tr/api/accounts/v1/list</a>
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>Base URL for Test Environment:</b><br/>
    <a href='https://apitest.albarakaturk.com.tr/api' style={{fontWeight: 'bold'}}>https://apitest.albarakaturk.com.tr/api</a>
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
    <b>Example URL for Test Environment:</b><br/>
    <a href='https://apitest.albarakaturk.com.tr/api/accounts/v1/list' style={{fontWeight: 'bold'}}>https://apitest.albarakaturk.com.tr/api/accounts/v1/list</a>
    </MUTypography>
    <br/>

    <MUTypography variant='display1' className={props.classes.paragraph}>
    Details on how to manage Request Signing (RSA encryption) required to use APIs in the production environment, and how to handle OTP processes for transactions requiring SMS or Mobile Confirmation via the execute service, are explained in the "Signing" and "OTP Handling" sections.
    </MUTypography>
    <br/>
    <br/>
  </div>;

export default Info3;

